import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

// Components
import EmblaCarousel from './embla/emblaCarousel'

const defaultOptions = { loop: true, autoplay: true, speed: 5000 }

const Image = ({ slice }) => {
  return (
    <section className='component-image_gallery w-full my-6'>
      <div>
        {/* 1 image = full width */}
        {slice.items.length === 1 && (
          <div className='mx-auto'>
            <GatsbyImage className='w-full' image={getImage(slice.items[0].image)} alt={slice.items[0].image.alt || ''} />
          </div>
        )}

        {/* 2+ images = gallery */}
        {slice.items.length > 1 && (
          <EmblaCarousel options={defaultOptions} slice={slice}>
            {slice.items.map((item, index) => {
              return (
                <div className={`embla__slide ${'item' + (index === 0 ? ' active' : '')}`} key={`item-${index}`} aria-selected={index === 0 ? 'true' : 'false'}>
                  <GatsbyImage image={getImage(item.image)} alt={item.image.alt || ''} />
                </div>
              )
            })}
          </EmblaCarousel>
        )}
      </div>
    </section>
  )
}

export default Image
